import { Injectable } from '@angular/core';
import { ApiService } from '../../core/services/api/api.service';

@Injectable({
  providedIn: 'root',
})
export class LabelService {
  constructor(private apiService: ApiService) {}

  getLabels(orderId: string, token: string): Promise<any> {
    return this.apiService.promissedGet(`label/labels/orders/${orderId}?token=${token}`, {
      responseType: 'text',
    });
  }
}
